import { openSSE } from '@repo/commons/utils'
import { PhoneStateWsStateEnum, type PhoneStateWsEvent } from '@repo/commons/models'

const PHONE_STATE_SSE_URL = '/api/shared/svp-vgate/stream/phone-state-notifications'
const PHONE_STATE_SSE_OPTIONS = {
	eventNames: { progress: 'message', keepalive: 'keepalive' },
	withCredentials: false
} as const

export const liveSessions = $state({
	count: 0,
	error: null as string | null
})

let consumerCount = 0
let stopSSE: VoidFunction | null = null
const speakingLines = new Map<number, boolean>()
const listeners = new Set<(payload: PhoneStateWsEvent) => void>()

const syncCount = () => {
	liveSessions.count = Array.from(speakingLines.values()).filter(Boolean).length
}

const resetState = () => {
	stopSSE?.()
	stopSSE = null
	listeners.clear()
	speakingLines.clear()
	liveSessions.count = 0
	liveSessions.error = null
}

const handleProgress = (payload: PhoneStateWsEvent) => {
	const line = Number.parseInt(payload.connectionName, 10)

	if (!Number.isNaN(line)) {
		speakingLines.set(line, payload.next === PhoneStateWsStateEnum.SPEAKING)
		syncCount()
	}

	listeners.forEach((listner) => listner(payload))
}

const startSSE = () => {
	const { close } = openSSE<PhoneStateWsEvent>(
		PHONE_STATE_SSE_URL,
		{
			onOpen: () => (liveSessions.error = null),
			onProgress: handleProgress,
			onError: () => (liveSessions.error = 'Phone-state stream error')
		},
		PHONE_STATE_SSE_OPTIONS
	)
	stopSSE = close
}

export const acquireLiveSessions = (onEvent?: (payload: PhoneStateWsEvent) => void) => {
	if (onEvent) {
		listeners.add(onEvent)
	}

	consumerCount++

	if (consumerCount === 1) {
		startSSE()
	}

	let released = false

	return () => {
		if (released) return
		released = true

		if (onEvent) {
			listeners.delete(onEvent)
		}

		consumerCount--

		if (consumerCount === 0) {
			resetState()
		}
	}
}

export const seedLiveSession = (line: number, isSpeaking: boolean) => {
	speakingLines.set(line, isSpeaking)

	syncCount()
}
